import useValidation from "./useValidation";
import primaryComponents from "../../../primaryComponents";
import { useBusinessAccountForm } from "./useBusinessAccountForm";

export const BusinessAccountForm = ({
  isEditMode = false,
  accountInfo = {},
  closeModal = () => {},
}) => {
  const { formData, isLoading, setFormData, handleAccount } =
    useBusinessAccountForm({
      isEditMode,
      accountInfo,
      closeModal,
    });
  const {
    register,
    control,
    formState: { errors },
    handleSubmit,
    trigger,
  } = useValidation({
    ...formData,
  });

  return (
    <div>
      <primaryComponents.InputFieldV2
        control={control}
        classNames="white"
        label={"Client ID"}
        placeholder={"Enter client ID"}
        name={"client_id"}
        value={formData?.client_id}
        isRequired={true}
        register={register}
        errorMessage={errors?.client_id}
        onKeyUp={() => errors?.client_id !== undefined && trigger("client_id")}
        onChange={({ target: { value } }) => {
          setFormData((prevState) => ({
            ...prevState,
            client_id: value,
          }));
        }}
      />

      <primaryComponents.InputFieldV2
        control={control}
        classNames="white"
        label={"Client Secret"}
        placeholder={"Enter client Secret"}
        name={"client_secret"}
        value={formData?.client_secret}
        isRequired={true}
        register={register}
        errorMessage={errors?.client_secret}
        onKeyUp={() =>
          errors?.client_secret !== undefined && trigger("client_secret")
        }
        onChange={({ target: { value } }) => {
          setFormData((prevState) => ({
            ...prevState,
            client_secret: value,
          }));
        }}
      />

      <primaryComponents.InputFieldV2
        control={control}
        classNames="white"
        label={"Merchant Name"}
        placeholder={"Enter merchant name"}
        name={"merchant_name"}
        value={formData?.merchant_name}
        isRequired={true}
        register={register}
        errorMessage={errors?.merchant_name}
        onKeyUp={() =>
          errors?.merchant_name !== undefined && trigger("merchant_name")
        }
        onChange={({ target: { value } }) => {
          setFormData((prevState) => ({
            ...prevState,
            merchant_name: value,
          }));
        }}
      />

      <primaryComponents.InputFieldV2
        control={control}
        classNames="white"
        label={"Merchant Code"}
        placeholder={"Enter merchant code"}
        name={"merchant_code"}
        value={formData?.merchant_code}
        isRequired={true}
        register={register}
        errorMessage={errors?.merchant_code}
        onKeyUp={() =>
          errors?.merchant_code !== undefined && trigger("merchant_code")
        }
        onChange={({ target: { value } }) => {
          setFormData((prevState) => ({
            ...prevState,
            merchant_code: value,
          }));
        }}
      />

      <primaryComponents.InputFieldV2
        control={control}
        classNames="white"
        label={"Webhook Secret"}
        placeholder={"Enter webhook secret"}
        name={"webhook_secret"}
        value={formData?.webhook_secret}
        isRequired={true}
        register={register}
        errorMessage={errors?.webhook_secret}
        onKeyUp={() =>
          errors?.webhook_secret !== undefined && trigger("webhook_secret")
        }
        onChange={({ target: { value } }) => {
          setFormData((prevState) => ({
            ...prevState,
            webhook_secret: value,
          }));
        }}
      />

      <primaryComponents.Button
        classNames={"ml-auto btn btn--primary w-100 mt-2"}
        onClick={handleSubmit(handleAccount)}
        isDisabled={isLoading}
        isLoading={isLoading}
        loadingText={"Connecting..."}
      >
        {isEditMode ? "Update Connection" : "Connect Account"}
      </primaryComponents.Button>
    </div>
  );
};
